import React from "react";
import { TransformWrapper, TransformComponent } from "react-zoom-pan-pinch";
import { fileUrl } from "@/lib/files";
import { UploadButton } from "@/components/fields";
import { Map as MapIcon } from "lucide-react";
import { TabHeader } from "@/components/royal";

export default function MapTab({ settings, saveSettings, editable }) {
  const url = fileUrl(settings.map_file_id);

  return (
    <div className="space-y-6">
      <TabHeader label="The Known World" title="Map">
        {editable && (
          <UploadButton label={settings.map_file_id ? "Replace Map" : "Upload Map"} accept="image/*"
            onUploaded={(r) => saveSettings({ map_file_id: r.file_id })} testId="upload-map" variant="default" />
        )}
      </TabHeader>

      {url ? (
        <div className="ht-panel overflow-hidden" style={{ height: "70vh" }} data-testid="map-viewer">
          <TransformWrapper minScale={0.5} maxScale={8} centerOnInit>
            <TransformComponent wrapperStyle={{ width: "100%", height: "100%" }} contentStyle={{ width: "100%", height: "100%" }}>
              <img src={url} alt="Kingdom map" className="w-full h-full object-contain" />
            </TransformComponent>
          </TransformWrapper>
        </div>
      ) : (
        <div className="ht-panel p-16 text-center text-muted-foreground flex flex-col items-center gap-3" data-testid="map-empty">
          <MapIcon strokeWidth={1.5} className="w-10 h-10 text-gold/50" />
          No map has been uploaded yet.
        </div>
      )}
      {url && <p className="text-xs text-muted-foreground">Scroll or pinch to zoom · drag to pan.</p>}
    </div>
  );
}
